/* eslint-disable camelcase */
import { reactive } from 'vue'
import { MessageChat, Reply } from '@/types/message'

const state = reactive<MessageChat[]>([])

export function getMessage (id: string): MessageChat | undefined {
  return state.find(message => message.uuid === id)
}

export function getMessageForReply (id: string): Reply | undefined {
  return state.find((message) => message.uuid === id)?.reply
}

export function setMessages (messages: MessageChat[]): void {
  const assign = Object.assign(messages, state)
  state.length = 0
  state.push(...assign)
}

export function addMessage (payload: MessageChat): void {
  state.push({ ...payload })
}

export function upMessage (payload: MessageChat): void {
  const index = state.findIndex(message => message.id === payload.id)
  if (index !== -1) {
    state[index] = {
      ...payload,
      status: 'sent'
    }
  }
}

export default state
